package horcrux.frontend.common.views.chat

import horcrux.common.ValidatedValueClass
import horcrux.frontend.common.views.components.input.EditTextFieldProps
import horcrux.frontend.common.views.components.input.editTextField
import js.objects.jso
import react.FC
import react.ReactNode


value class InputPrompt(override val value: String) : ValidatedValueClass<String, InputPrompt>

val EditInputPrompt =
    { value: String -> InputPrompt(value) }.editTextField {
        this.id = "edit-input-prompt"
        this.label = ReactNode("Input your message")
        this.fullWidth = true
    }

val EditInputPromptWithHelp = FC<EditTextFieldProps<InputPrompt>> { props ->
    EditInputPrompt {
        +props
        this.helpTextMaybe =
            "You can input your first message at the same time you import your documents, and we will do our best to answer it. You can also input as many messages as you want later."
        this.textFieldPropsMaybe = jso {
            this.label = ReactNode("Input your message (Optional)")
            this.autoComplete = "off"
        }
    }
}
